const useLocale = () => {
  const params = new URLSearchParams(window.location.search)
  return params.get('locale') || null
}

export default useLocale
